import { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    turnstile?: {
      render: (
        el: HTMLElement,
        opts: {
          sitekey: string;
          theme?: "light" | "dark" | "auto";
          callback: (token: string) => void;
          "error-callback"?: () => void;
          "expired-callback"?: () => void;
        },
      ) => string;
      reset: (widgetId?: string) => void;
    };
  }
}

export function TurnstileWidget({
  onToken,
  onError,
}: {
  onToken: (token: string) => void;
  onError: () => void;
}) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const widgetIdRef = useRef<string | null>(null);
  const [loaded, setLoaded] = useState(!!window.turnstile);

  useEffect(() => {
    if (loaded) return;
    const t = setInterval(() => {
      if (window.turnstile) {
        setLoaded(true);
        clearInterval(t);
      }
    }, 100);
    const timeout = setTimeout(() => {
      if (!window.turnstile) {
        onError();
        clearInterval(t);
      }
    }, 8000);
    return () => {
      clearInterval(t);
      clearTimeout(timeout);
    };
  }, [loaded, onError]);

  useEffect(() => {
    if (!loaded || !containerRef.current || widgetIdRef.current) return;
    widgetIdRef.current = window.turnstile!.render(containerRef.current, {
      sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
      theme: "dark",
      callback: onToken,
      "error-callback": onError,
      "expired-callback": onError,
    });
  }, [loaded, onToken, onError]);

  return <div ref={containerRef} data-testid="turnstile" />;
}
